import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=05ba185e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=05ba185e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba185e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ba185e')) {
      api.createRecord('05ba185e', component.options)
    } else {
      api.reload('05ba185e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=05ba185e&scoped=true&", function () {
      api.rerender('05ba185e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/comp/Paginate.vue"
export default component.exports